import { render, staticRenderFns } from "./Origin-Total.vue?vue&type=template&id=15a94071&scoped=true"
import script from "./Origin-Total.vue?vue&type=script&lang=js"
export * from "./Origin-Total.vue?vue&type=script&lang=js"
import style0 from "./Origin-Total.vue?vue&type=style&index=0&id=15a94071&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15a94071",
  null
  
)

export default component.exports